import { Grid } from "@material-ui/core";
import React, { Component } from "react";
import { Typography } from "@mui/material";
import axios from "axios";

export default class SharePdfViewer extends Component {
  state = {
    static_url: "/static/pdfjs/web/viewer.html?file=",
    file_url: "",
    file_name: "",
  };

  componentDidMount() {
    axios
      .get("/api/categories/dfs_url?file_id=" + this.props.match.params.file_id)
      .then((res) => {
        this.setState({
          file_url: res.data.dfs_url,
          file_name: res.data.file_name,
        });
      });
  }

  render() {
    return (
      <Grid>
        <Typography>{"文件名称：" + this.state.file_name}</Typography>
        <iframe
          src={this.state.static_url + this.state.file_url}
          title="preview"
          frameborder="0"
          height="1280px"
          width="100%"
        ></iframe>
      </Grid>
    );
  }
}
